import { Component } from "react"
import PropTypes from "prop-types"
import takeRight from "lodash/takeRight"
import _map from "lodash/map"
import moment from "moment"

export default class AppletsActivationChartOn extends Component {
  constructor(props) {
    super(props)
  }

  async componentDidMount() {
    const Highcharts = await import("highcharts")
    Highcharts.setOptions(window.globalHighchartsOptions)

    const settings = {
      chart: {
        animation: false,
        renderTo: this.chartContainer,
        height: 250,
        spacing: [10, 0, 10, 0],
      },
      credits: { enabled: false },
      title: {
        text: "",
      },
      legend: {
        enabled: false,
      },
      plotOptions: {
        column: {
          borderWidth: 0,
          stacking: "normal",
        },
      },
      xAxis: {
        type: "datetime",
        tickmarkPlacement: "on",
        labels: {
          step: 4,
          style: {
            color: "#999",
            fontSize: "14",
            fontWeight: "700",
          },
        },
        offset: 10,
        gridLineWidth: 4,
        gridLineColor: "#f5f5f5",
        lineWidth: 0,
        tickWidth: 0,
      },
      yAxis: [
        {
          title: {
            enabled: false,
          },
          labels: {
            style: {
              color: "#999",
              fontSize: "14",
              fontWeight: "700",
            },
            formatter: data => {
              return Highcharts.numberFormat(data.value, 0)
            },
          },
          gridLineWidth: 0,
        },
        {
          opposite: true,
          title: {
            enabled: false,
          },
          labels: {
            enabled: false,
          },
        },
      ],
      series: [
        {
          name: "On",
          color: "#70d600",
          type: "column",
          pointWidth: 12,
          states: {
            hover: {
              enabled: false,
            },
          },
        },
      ],
      tooltip: {
        animation: false,
        backgroundColor: "#333",
        borderWidth: 0,
        borderRadius: 10,
        headerFormat: '<span style="color: #999">{point.key}</span>',
        padding: 8,
        pointFormat: "<br><b>{point.y} turned on</b>",
        shared: true,
        shadow: false,
        style: {
          color: "#fff",
          fontSize: 14,
        },
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 483,
            },
            chartOptions: {
              series: [
                {
                  data: takeRight(this.extractFirstLayer(), 15),
                  pointWidth: 8,
                },
              ],
              xAxis: {
                categories: takeRight(this.xAxisCategories(), 15),
              },
            },
          },
          {
            condition: {
              minWidth: 484,
            },
            chartOptions: {
              series: [
                {
                  data: this.extractFirstLayer(),
                  pointWidth: 10,
                },
              ],
              xAxis: {
                categories: this.xAxisCategories(),
              },
            },
          },
        ],
      },
    }

    this.chart = new Highcharts.Chart(settings)
  }

  componentWillUnmount() {
    this.chart.destroy()
  }

  xAxisCategories() {
    // both layers have the same dates
    const layer = this.props.data[0]
    return _map(layer, row => {
      return moment(row.date).format("MMM D")
    })
  }

  extractSecondLayer() {
    const layer = this.props.data[1]
    return _map(layer, row => {
      return parseInt(row.applets)
    })
  }

  extractFirstLayer() {
    const layer = this.props.data[0]
    return _map(layer, row => {
      return parseInt(row.applets)
    })
  }

  render() {
    return (
      <div
        className="chart-container round-grid-chart applets-activation-chart"
        ref={c => (this.chartContainer = c)}
      />
    )
  }
}

AppletsActivationChartOn.propTypes = {
  data: PropTypes.array.isRequired,
  settings: PropTypes.object,
}
